import Analytics from '@components/charts/analytics/Analytics'
import AnswerChart from '@components/charts/membership/AnswerChart'
import OnboardingFunnel from '@components/charts/membership/OnboardingFunnel'
import RequestBarChart from '@components/charts/membership/RequestBarChart'
import Engagement from '@components/charts/membership/revenue/Engagement'
import Feature from '@components/Feature'
import { useHasAccess } from '@components/HasAccess'
import Page from '@components/Page/Page'
import { AnalyticsProvider } from '@contexts/AnalyticsContext'
import {
  analyticsRangePresets,
  defaultAnalyticsRange,
} from '@utils/membershipRangePresets'
import { useFeature } from '@utils/featureFlags'
import { Permission } from '@utils/permissions'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { Col, Space } from 'antd'
import dayjs from 'dayjs'
import { useMemo } from 'react'

const AnalyticsContent = () => {
  const rangePresets = useMemo(() => analyticsRangePresets(), [])
  const defaultRange = useMemo(() => defaultAnalyticsRange(), [])
  const { hasAccess } = useHasAccess()
  // The engagement endpoint is gated by the revenue permission and flag. The
  // Col only exists when the section does (an empty Col still adds a gutter);
  // `Feature` inside frames the section when it is a preview.
  const showEngagement =
    useFeature('membershipAnalyticsOverview').enabled &&
    hasAccess(Permission.viewRevenueMembership)

  return (
    <Page
      rowGutter={[32, 32]}
      noWrapWithCol
      pageTitle={{
        title: 'Onboarding',
        level: 4,
        toolbar: (
          <Space orientation="horizontal">
            <Analytics.MembershipProgram />
            <Analytics.Date
              rangePresets={rangePresets}
              defaultValue={defaultRange}
              maxDate={dayjs()}
            />
          </Space>
        ),
      }}
    >
      <Col span={24}>
        <Space orientation="vertical" className="w-full" size={8}>
          <PageTitle
            level={5}
            title="Received Requests"
            style={{ margin: 0 }}
          />
          <RequestBarChart />
        </Space>
      </Col>
      <Col span={12}>
        <Space orientation="vertical" className="w-full" size={8}>
          <PageTitle
            level={5}
            title="Onboarding Conversion"
            style={{ margin: 0 }}
          />
          <OnboardingFunnel />
        </Space>
      </Col>
      <Col span={12}>
        <Space orientation="vertical" className="w-full" size={8}>
          <PageTitle
            level={5}
            title="Onboarding Questions"
            style={{ margin: 0 }}
          />
          <AnswerChart />
        </Space>
      </Col>
      {showEngagement && (
        <Col span={24}>
          <Feature flag="membershipAnalyticsOverview" preview="section">
            <Engagement />
          </Feature>
        </Col>
      )}
    </Page>
  )
}

const AnalyticsPage = () => {
  return (
    <AnalyticsProvider membershipProgramScoped>
      <AnalyticsContent />
    </AnalyticsProvider>
  )
}

export default AnalyticsPage
